import { atom } from 'jotai';
import { IUser } from '@/helpers/interfaces/users.interface';

export const userAtom = atom<IUser | null>(null);
export const userPermissionsAtom = atom<string[]>();

export const setUserPhoneAtom = atom(null, (get, set, phone: string) => {
  const user = get(userAtom);
  if (user) set(userAtom, { ...user, phone });
});

export const setPhoneConfirmedAtom = atom(null, (get, set, phoneConfirmed: boolean) => {
  const user = get(userAtom);
  if (user) set(userAtom, { ...user, phoneConfirmed });
});

export const setUserWorkspaceDataAtom = atom(null, (get, set, workspace: Partial<IUser['workspace']>) => {
  const user = get(userAtom);
  if (user) set(userAtom, { ...user, workspace: { ...user.workspace, ...workspace } });
});

export const setWorkspacePhoneAtom = atom(null, (get, set, phone: string) => {
  const user = get(userAtom);
  if (user) set(userAtom, { ...user, workspace: { ...user.workspace, phone } });
});

export const setWorkspacePhoneConfirmedAtom = atom(null, (get, set, phoneConfirmed: boolean) => {
  const user = get(userAtom);
  if (user) set(userAtom, { ...user, workspace: { ...user.workspace, phoneConfirmed } });
});
